import { RequestPayload, ResponseData, SuccessResponseDTO } from '../../dtos/generic'
import { defineRoute } from '../new-helpers'

export const PublicAuthRoutes = {
  login: defineRoute<
    'POST',
    ResponseData<{ access_token: string }>,
    RequestPayload<{
      email: string
      password: string
    }>
  >({
    path: '/auth/login',
  }),

  signup: defineRoute<
    'POST',
    ResponseData<SuccessResponseDTO>,
    RequestPayload<{
      email: string
      firstName: string
      lastName: string
    }>
  >({
    path: '/auth/signup',
  }),
}
